import { defaultMemoize } from 'reselect';
import getIn from 'transmute/getIn';
export const getIndexedAsyncFileAttachments = defaultMemoize(getIn(['threadViewRootReducer', 'fileAttachments']));